export default class AuthorizeTwitter {
  constructor(context) {
    this.context = context;
  }

  run() {
    const orgId = this.context.stores.auth.get().getOrgId();
    const url = `/api/v1/orgs/${orgId}/messaging/auth/twitter/initiate`;
    window.open(url, 'TwitterAuthentication', 'width=800,height=800');
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/authorize_twitter.js